"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCompetitionResource = instanceOfCompetitionResource;
exports.CompetitionResourceFromJSON = CompetitionResourceFromJSON;
exports.CompetitionResourceFromJSONTyped = CompetitionResourceFromJSONTyped;
exports.CompetitionResourceToJSON = CompetitionResourceToJSON;
exports.CompetitionResourceToJSONTyped = CompetitionResourceToJSONTyped;
var InvolvementViewResource_1 = require("./InvolvementViewResource");
var RelToHrefs_1 = require("./RelToHrefs");
var Issue_1 = require("./Issue");
var CompetitionState_1 = require("./CompetitionState");
var ListingMode_1 = require("./ListingMode");
var IdResource_1 = require("./IdResource");
var StringIdResource_1 = require("./StringIdResource");
var Expanded_1 = require("./Expanded");
/**
 * Check if a given object implements the CompetitionResource interface.
 */
function instanceOfCompetitionResource(value) {
    return true;
}
function CompetitionResourceFromJSON(json) {
    return CompetitionResourceFromJSONTyped(json, false);
}
function CompetitionResourceFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        '_issues': json['_issues'] == null ? undefined : (json['_issues'].map(Issue_1.IssueFromJSON)),
        '_restrictToCommunities': json['_restrictToCommunities'] == null ? undefined : (json['_restrictToCommunities'].map(IdResource_1.IdResourceFromJSON)),
        '_viewInvolvement': json['_viewInvolvement'] == null ? undefined : (0, InvolvementViewResource_1.InvolvementViewResourceFromJSON)(json['_viewInvolvement']),
        'name': json['name'] == null ? undefined : json['name'],
        'game': json['game'] == null ? undefined : (0, StringIdResource_1.StringIdResourceFromJSON)(json['game']),
        'image': json['image'] == null ? undefined : json['image'],
        'disambiguatingDescription': json['disambiguatingDescription'] == null ? undefined : json['disambiguatingDescription'],
        'state': json['state'] == null ? undefined : (0, CompetitionState_1.CompetitionStateFromJSON)(json['state']),
        'listingMode': json['listingMode'] == null ? undefined : (0, ListingMode_1.ListingModeFromJSON)(json['listingMode']),
        'ordinal': json['ordinal'] == null ? undefined : json['ordinal'],
        'organization': json['organization'] == null ? undefined : (0, IdResource_1.IdResourceFromJSON)(json['organization']),
        'profile': json['profile'] == null ? undefined : (0, IdResource_1.IdResourceFromJSON)(json['profile']),
        'section': json['section'] == null ? undefined : (0, IdResource_1.IdResourceFromJSON)(json['section']),
        'settings': json['settings'] == null ? undefined : (0, IdResource_1.IdResourceFromJSON)(json['settings']),
        'rules': json['rules'] == null ? undefined : (0, IdResource_1.IdResourceFromJSON)(json['rules']),
        'channel': json['channel'] == null ? undefined : (0, IdResource_1.IdResourceFromJSON)(json['channel']),
        'restricted': json['restricted'] == null ? undefined : json['restricted'],
        'dateTouched': json['dateTouched'] == null ? undefined : (new Date(json['dateTouched'])),
        '_expanded': json['_expanded'] == null ? undefined : (0, Expanded_1.ExpandedFromJSON)(json['_expanded']),
        '_links': json['_links'] == null ? undefined : (0, RelToHrefs_1.RelToHrefsFromJSON)(json['_links']),
    };
}
function CompetitionResourceToJSON(json) {
    return CompetitionResourceToJSONTyped(json, false);
}
function CompetitionResourceToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        '_issues': value['_issues'] == null ? undefined : (value['_issues'].map(Issue_1.IssueToJSON)),
        '_restrictToCommunities': value['_restrictToCommunities'] == null ? undefined : (value['_restrictToCommunities'].map(IdResource_1.IdResourceToJSON)),
        '_viewInvolvement': (0, InvolvementViewResource_1.InvolvementViewResourceToJSON)(value['_viewInvolvement']),
        'name': value['name'],
        'game': (0, StringIdResource_1.StringIdResourceToJSON)(value['game']),
        'image': value['image'],
        'disambiguatingDescription': value['disambiguatingDescription'],
        'state': (0, CompetitionState_1.CompetitionStateToJSON)(value['state']),
        'listingMode': (0, ListingMode_1.ListingModeToJSON)(value['listingMode']),
        'ordinal': value['ordinal'],
        'organization': (0, IdResource_1.IdResourceToJSON)(value['organization']),
        'profile': (0, IdResource_1.IdResourceToJSON)(value['profile']),
        'section': (0, IdResource_1.IdResourceToJSON)(value['section']),
        'settings': (0, IdResource_1.IdResourceToJSON)(value['settings']),
        'rules': (0, IdResource_1.IdResourceToJSON)(value['rules']),
        'channel': (0, IdResource_1.IdResourceToJSON)(value['channel']),
        'restricted': value['restricted'],
        'dateTouched': value['dateTouched'] == null ? undefined : ((value['dateTouched']).toISOString()),
        '_expanded': (0, Expanded_1.ExpandedToJSON)(value['_expanded']),
        '_links': (0, RelToHrefs_1.RelToHrefsToJSON)(value['_links']),
    };
}
